import * as constants from '../constants/completedJob-consts'
import { CompletedJobActions } from '../actions/setCompletedJob'
import { Job } from '../types'

export interface CompletedJobState { }

const initialState = null

export function completedJobReducer(state = initialState, action: CompletedJobActions) {
  switch (action.type) {
    case constants.COMPLETED_JOB:
      let state = action.completedJob
      return state
  }
  return state
}



// WEBPACK FOOTER //
// ./src/reducers/setCompletedJob.ts